export default "/_next/static/images/cb/cooperation-cb01863e56041050efcb85c8728a8eb6.jpg";